import fetch from '../utils/fetch';
import { serviceAwardsURL } from 'endpoints';

class ServiceAwardsSDK {

    getPrograms = ( ) => {
        return new Promise( ( resolve, reject ) => {
            fetch( `${ serviceAwardsURL }/report/filter-options`, {
                method: 'GET',
                headers: { 'content-type': 'application/json' }
            } )
            .then( ( res ) => {
                if ( res.ok ) {
                    res.json().then( ( data ) => {
                        resolve( data.programs );
                    } );
                } else {
                    res.json().then( ( data ) => {
                        reject( data.message );
                    } );
                }
            } )
            .catch ( ( err ) => {
                console.error( err );
                reject( err.message );
            } );
        } );
    };

}

export default new ServiceAwardsSDK();


